
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { DateHelper } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { IMember, ITeamWebsite } from "../../../../../services";
import { i18nManager as globalI18nManager } from "../../../../../i18n";
import { DASHBOARD_URL, pagePath, teamInitials, teamLogo, visiblePages } from "../../helpers";

export interface FooterProps {
    basePath: string;
    profile?: IMember;
    website: ITeamWebsite;
}

function Footer({ website, basePath, profile }: FooterProps) {

    const mainLabels = globalI18nManager.Labels;
    const year = DateHelper.getStartOfDay().getFullYear();
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const owner = website.owns_copyright ? website.team.name : mainLabels.omnehost;
    const socials = Object.entries(website.owns_copyright ? (website.social_accounts ?? {}) : Utils.OMNEHOST_SOCIALS);
    const logo = teamLogo(website);

    return (<footer className={styles["footer"]}>
        <div className={styles["container"]}>
            <div className={styles["footer-top"]}>
                <div className={styles["footer-brand"]}>
                    {logo ? (<img className={styles["footer-logo"]} src={logo} alt={website.team.name} />) : (<span className={styles["nav-logo-text"]}>{teamInitials(website.team.name)}</span>)}
                    <p>{website.owns_copyright ? (website.team.description || i18nManager.Labels.footer.established.replace(":name", website.team.name)) : mainLabels.omnehost_detail}</p>
                </div>
                <nav className={styles["footer-links"]}>
                    {visiblePages(website).map(([page, pageSettings]) => (
                        <ReactRouterDom.NavLink key={page} end to={{ pathname: pagePath(basePath, page), search: searchParams.toString() }} className={styles["footer-link"]}>{pageSettings.label}</ReactRouterDom.NavLink>
                    ))}
                    {!website.owns_copyright && (<>
                        <a target="_blank" rel="noreferrer" href={DASHBOARD_URL} className={styles["footer-link"]}>{profile ? mainLabels.auth.dashboard : mainLabels.auth.sign_in}</a>
                        {mainLabels.footer.map((f) => (<a key={f.label} target="_blank" rel="noreferrer" href={f.location} className={styles["footer-link"]}>{f.label}</a>))}
                    </>)}
                </nav>
            </div>
            <div className={styles["line-divider"]} />
            <div className={styles["footer-bottom"]}>
                <span className={styles["footer-legal"]}>© {year} {owner}. {mainLabels.landing.all_r_reserved}</span>
                <div className={styles["footer-socials"]}>
                    {socials.map(([social, username]) => (
                        <ReactRouterDom.NavLink key={social} target="_blank" to={Utils.getSocialLink(social, username as string)} aria-label={social} className={styles["topbar-link"]}>
                            <i className={Utils.getSocialIcon(social) ?? "fa fa-link"} />
                        </ReactRouterDom.NavLink>
                    ))}
                </div>
            </div>
        </div>
    </footer>);
}

export default Footer;
